import { gql } from '@apollo/client';

export const fetchSandboxParent = gql`
  query fetchSandboxParent($id: String) {
    entitlementDetails(id: $id) {
      productId
      entitlementNumber
      billingStatus
      provisioningStatus
      edition
      productName
      isSandbox
      subscriptionTimestamps {
        firstStartTimestamp
        lastEndTimestamp
        firstTrialStartTimestamp
        lastTrialEndTimestamp
      }
    }
  }
`;
